import { withStylePrefix } from '../../common/withStylePrefix';
import { ProgressStepComponent, progressStepTemplate } from './ProgressStep';
import styles from './ProgressStep.styles.scss';
export const progressStepDefinition = {
    baseName: 'progress-step',
    template: progressStepTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonProgressStep = ProgressStepComponent.compose(progressStepDefinition);
